/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

angular.module('prism-ui.components.data').factory('PartnerResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.partnerEndPoint + '/:id',
        {
            id: '@id',
            fetchOffset: '@fetchOffset',
            fetchLimit: '@fetchLimit',
            searchString: '@searchString',
            includeHidden: '@includeHidden',
            mvpd: '@mvpd'
        },

        {
            //==========//
            // Partners //
            //==========//

            clone: {
                method: 'POST',
                url: EndPointService.partnerEndPoint + '/:id',
                params: {id: '@id'},
                isArray: false
            },
            update: {
                method: 'PUT',
                url: EndPointService.partnerEndPoint + '/:id',
                params: {id: '@id'},
                isArray: false
            },
            toggleArchive: {
                method: 'DELETE',
                url: EndPointService.partnerEndPoint + '/:id',
                params: {id: '@id'},
                isArray: false
            },

            getChildren: {
                method: 'GET',
                url: `${EndPointService.partnerEndPoint}/:id/children`,
                isArray: true
            },

            //=============================//
            // Partner Metadata Properties //
            //=============================//

            getMetadataProperties: {
                method: 'GET',
                url: EndPointService.partnerEndPoint + '/:id/metadataProperties',
                params: {id: '@id'},
                isArray: true
            },

            //==================//
            // Partner Planners //
            //==================//

            getAllPlanners: {
                method: 'GET',
                url: EndPointService.partnerEndPoint + '/planners',
                interceptor: {
                    response: function (response) {
                        response.resource.$httpHeaders = response.headers;
                        return response.resource;
                    }
                },
                isArray: true
            },
            getPlanners: {
                method: 'GET',
                url: EndPointService.partnerEndPoint + '/:id/planners',
                params: {id: '@id'},
                isArray: true
            },
            createPlanner: {
                method: 'POST',
                url: EndPointService.partnerEndPoint + '/:id/planners',
                params: {id: '@id'},
                isArray: false
            },
            getPlanner: {
                method: 'GET',
                url: EndPointService.partnerEndPoint + '/planners/:id',
                params: {id: '@id'},
                isArray: false
            },
            updatePlanner: {
                method: 'PUT',
                url: EndPointService.partnerEndPoint + '/planners/:id',
                params: {id: '@id'},
                isArray: false
            },
            deletePlanner: {
                method: 'DELETE',
                url: EndPointService.partnerEndPoint + '/planners/:id',
                params: {id: '@id'},
                isArray: false
            },
            deliverOffCyclePlanners: {
                method: 'GET',
                params: {
                    plannerId: '@plannerId',
                    message: '@message'
                },
                url: EndPointService.partnerEndPoint + '/offCyclePlanners',
                isArray: false
            },

            //============================//
            // Partner Delivery Endpoints //
            //============================//

            getDeliveryEndpoints: {
                method: 'GET',
                url: EndPointService.partnerEndPoint + '/:id/deliveryEndpoints',
                params: {id: '@id'},
                isArray: true
            },
            createDeliveryEndpoint: {
                method: 'POST',
                url: EndPointService.partnerEndPoint + '/:partnerId/deliveryEndpoints',
                params: {id: '@partnerId'},
                isArray: false
            },
            cloneDeliveryEndpoint: {
                method: 'POST',
                url: EndPointService.partnerEndPoint + '/:partnerId/deliveryEndpoints/:endpointId',
                params: {partnerId: '@partnerId', endpointId: '@endpointId'},
                isArray: false
            },
            getDeliveryEndpoint: {
                method: 'GET',
                url: EndPointService.partnerEndPoint + '/deliveryEndpoints/:endpointId',
                params: {id: '@endpointId'},
                isArray: false
            },
            updateDeliveryEndpoint: {
                method: 'PUT',
                url: EndPointService.partnerEndPoint + '/deliveryEndpoints/:endpointId',
                params: {id: '@endpointId'},
                isArray: false
            },
            deleteDeliveryEndpoint: {
                method: 'DELETE',
                url: EndPointService.partnerEndPoint + '/deliveryEndpoints/:id',
                params: {id: '@id'},
                isArray: false
            },

            //=========================//
            // Partner Email Endpoints //
            //=========================//

            getEmailEndpoints: {
                method: 'GET',
                url: EndPointService.partnerEndPoint + '/:partnerId/emailEndpoints',
                isArray: true,
            },
            getEmailEndpoint: {
                method: 'GET',
                url: EndPointService.partnerEndPoint + '/emailEndpoints/:id',
            },
            createEmailEndpoint: {
                method: 'POST',
                url: EndPointService.partnerEndPoint + '/:partnerId/emailEndpoints',
            },
            cloneEmailEndpoint: {
                method: 'POST',
                url: EndPointService.partnerEndPoint + '/emailEndpoints/:id',
            },
            updateEmailEndpoint: {
                method: 'PUT',
                url: EndPointService.partnerEndPoint + '/emailEndpoints/:id',
            },
            toggleEmailEndpointVisibility: {
                method: 'DELETE',
                url: EndPointService.partnerEndPoint + '/emailEndpoints/:id',
            },

            //===============
            // SLA Templates
            //===============

            getDueDateTemplates: {
                method: 'GET',
                url: `${EndPointService.partnerEndPoint}/:partnerId/dueDateTemplates`,
                isArray: true
            },
            cloneDueDateTemplate: {
                method: 'POST',
                url: `${EndPointService.partnerEndPoint}/dueDateTemplates/:id`
            },
            createDueDateTemplate: {
                method: 'POST',
                url: `${EndPointService.partnerEndPoint}/:partnerId/dueDateTemplates`
            },
            getDueDateTemplate: {
                method: 'GET',
                url: `${EndPointService.partnerEndPoint}/dueDateTemplates/:id`
            },
            updateDueDateTemplate: {
                method: 'PUT',
                url: `${EndPointService.partnerEndPoint}/dueDateTemplates/:id`
            },
            toggleDueDateTemplateVisibility: {
                method: 'DELETE',
                url: `${EndPointService.partnerEndPoint}/dueDateTemplates/:id`
            },

            //============//
            // Businesses //
            //============//

            getBusinesses: {
                method: 'GET',
                url: `${EndPointService.partnerEndPoint}/businesses`,
                isArray: true
            },

            getNielsenTemplates: {
                method: 'GET',
                url: `${EndPointService.partnerEndPoint}/:partnerId/nielsenTemplates`,
                isArray: true
            },
            cloneNielsenTemplate: {
                method: 'POST',
                url: `${EndPointService.partnerEndPoint}/nielsenTemplates/:id`,
                params: {id: '@id'}
            },
            createNielsenTemplate: {
                method: 'POST',
                url: `${EndPointService.partnerEndPoint}/:partnerId/nielsenTemplates`
            },
            getNielsenTemplate: {
                method: 'GET',
                url: `${EndPointService.partnerEndPoint}/nielsenTemplates/:id`
            },
            updateNielsenTemplate: {
                method: 'PUT',
                url: `${EndPointService.partnerEndPoint}/nielsenTemplates/:id`
            },
            toggleNielsenTemplateHidden: {
                method: 'DELETE',
                url: `${EndPointService.partnerEndPoint}/nielsenTemplates/:id`
            },
            getDeliveryProfiles: {
                method: 'GET',
                url: `${EndPointService.partnerEndPoint}/:partnerId/deliveryProfiles`,
                isArray: true
            },
            getDeliveryProfile: {
                method: 'GET',
                params: {
                    includeHiddenEmails: '@includeHiddenEmails'
                },
                url: `${EndPointService.deliveryEndPoint}/profiles/:profileId`
            },
            createDeliveryProfile: {
                method: 'POST',
                url: `${EndPointService.partnerEndPoint}/:partnerId/deliveryProfiles`
            },
            updateDeliveryProfile: {
                method: 'PUT',
                url: `${EndPointService.deliveryEndPoint}/profiles/:id`
            },
            toggleDeliveryEmailHidden: {
                method: 'DELETE',
                url: `${EndPointService.deliveryEndPoint}/profiles/:profileId/emails/:id`,
                params: {profileId: '@profileId'}
            },
            getDeliveryEmail: {
                method: 'GET',
                url: `${EndPointService.deliveryEndPoint}/profiles/:profileId/emails/:id`,
                params: {profileId: '@profileId'}
            },
            updateDeliveryEmail: {
                method: 'PUT',
                url: `${EndPointService.deliveryEndPoint}/profiles/:profileId/emails/:id`,
                params: {profileId: '@profileId'}
            },
            createDeliveryEmail: {
                method: 'POST',
                url: `${EndPointService.deliveryEndPoint}/profiles/:profileId/emails/`,
                params: {profileId: '@profileId'}
            },
            getDeliveryItemsForProfile: {
                method: 'GET',
                isArray: true,
                params: {
                    includeHidden: '@includeHidden',
                    acceptProfileId: '@acceptProfileId',
                    profileId: '@profileId',
                    fetchOffset: '@fetchOffset',
                    fetchLimit: '@fetchLimit',
                    type: '@type'
                },
                url: `${EndPointService.deliveryEndPoint}/profiles/:profileId/deliveryItems`
            },
            toggleDeliveryItemHidden: {
                method: 'DELETE',
                url: `${EndPointService.deliveryEndPoint}/items/:id`
            },
            cloneDeliveryItem: {
                method: 'POST',
                url: `${EndPointService.deliveryEndPoint}/items/:id`
            },
            getDeliveryItem: {
                method: 'GET',
                url: `${EndPointService.deliveryEndPoint}/items/:id`
            },
            updateDeliveryItem: {
                method: 'PUT',
                url: `${EndPointService.deliveryEndPoint}/items/:id`
            },
            createDeliveryItem: {
                method: 'POST',
                url: `${EndPointService.deliveryEndPoint}/items`
            }
        });
});
